import {Component} from "inferno";
import {Button, Popover, PopoverBody} from "inferno-bootstrap";
import {Tooltip} from "../../../components/Tooltip";
import {Manager, Target} from 'inferno-popper';
import {Bundle} from "../../../services/translationProvider";
import 'unicode-emoji-picker';
import { EmojiPickerElement } from 'unicode-emoji-picker';
import '../../../resources/css/unicodeEmojiPicker.css';

export class Emoji extends Component<any, any> {
	state = {
		input: "",
		open: false,
	};
	private panel: any;

	toggle = async () => {
		const open = !this.state.open;
		if (open) {
			this.setState({open: open});
			const emojiPicker = document.querySelector('unicode-emoji-picker');
			emojiPicker.addEventListener('emoji-pick', this.onSelect);
		} else {
			const emojiPicker = document.querySelector('unicode-emoji-picker');
			emojiPicker.removeEventListener('emoji-pick', this.onSelect);
			this.setState({open: open});
		}
	};

	onSelect = (event: any) => {
		this.toggle();
		this.props.onSelect(event.detail.emoji);
	};

	render() {
		return (
			<Manager className="emoji-popover">
				<Target className="d-inline">
					<Button disabled={!this.props.active} id="emoji-btn" color="link" style={{"text-decoration": "none"}} onClick={this.toggle}>
						<Tooltip target="emoji-btn" content="VCC_XTOL_CHAT_EMOJI_TOOLTIP" placement="top"/>
						<span>🙂</span>
					</Button>
				</Target>
				<Popover placement="top" isOpen={this.state.open} target="emoji-btn">
					<PopoverBody style={{padding:0}}>
						<unicode-emoji-picker default-group="face-emotion"></unicode-emoji-picker>
					</PopoverBody>
				</Popover>
			</Manager>
		);
	}
}
